import { useEffect, useState } from "react";
import classNames from "classnames";
import { TextIcon } from "components/atoms/TextIcon";
import { Typography } from "components/atoms/Typography";
import { Button } from "components/atoms/Button";
import { useAppSelector, useAppDispatch, useScreenSize } from "hooks";
import {
  TAB_WIDTH,
  MOBILE_WIDTH,
  DASHBOARD_PROGRAME,
  SELF_PACED_PROGRAME,
  MCAT_TEST_TYPE,
} from "utils/constants";
import "./index.scss";
import { CloseIcon } from "components/atoms/Icon";
import { Modal } from "../Modal";
import { RefreshModal } from "../RefreshModal";
import { PracticeModalInnerCard } from "../PracticeModalInnerCard";
import {
  useGetPracticeTestsQuery,
  useGetTestResultsQuery,
} from "services/practice";
import { mixpanelHelper } from "utils/functions/mixPanelHelper";
import { decodeToken } from "utils/functions/decodeToken";
import {
  useGetCourseworkQuery,
  useGetOverallProgressQuery,
  useGetTestScoresAndPerformanceQuery,
} from "services/homeApi";
import { useSegmentReFetch } from "context";
import { getObjectKeysByValue } from "services/helpers";
import { getTimeFilterInput } from "utils/functions/getTimeFilterInput";
import { useNavigate } from "react-router-dom";
import { UnlockModal } from "components/organisms/SelfPacedHomeworkTab/UnlockModal";
import { ai_mcat_chat_status } from "state/reducers/layoutSlice";
import { openExternalUrl } from "utils/functions/openExternalUrl";
 

interface IProps {
  theme: "light" | "dark";
  index: number;
  textIconLabel: string;
  iconType?: undefined | "yellow-timer" | "select" | "empty-circle" | "lock";
  btnLabel: string;
  middleLabel: string;
  isBtn?: boolean;
  isSecondBtn?: boolean;
  secondBtnLabel?: string;
  isMobile: boolean;
  primaryBtnLink?: string;
  secondaryBtnLink?: string;
  isCourseIndex?: boolean;
  item?: any;
  contentObjectType?: string;
}

export const PracticeTabRow = ({
  theme,
  index,
  textIconLabel,
  iconType,
  btnLabel,
  middleLabel,
  isSecondBtn,
  secondBtnLabel,
  isBtn,
  isMobile,
  primaryBtnLink,
  secondaryBtnLink,
  isCourseIndex,
  item,
  contentObjectType,
}: IProps) => {
  const [responsiveMiddleLabel, setResponsiveMiddleLabel] = useState("");
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [modalSelector, setModalSelector] = useState<"both" | "paper & pencil">(
    "both"
  );
  const [bubbleSheeetPdfUrl, setBubbleSheetPdfUrl] = useState("");
  const [onlineProctor, setOnlineProctor] = useState("");
  const [onlineProctor_1, setOnlineProctor_1] = useState("");
  const [onlineProctor_2, setOnlineProctor_2] = useState("");
  const [onlineProctor_3, setOnlineProctor_3] = useState("");
  const [isRefreshModalOpen, setIsRefreshModalOpen] = useState({
    isOpen: false,
    data: "",
  });
  const dispatch = useAppDispatch();

  const { selectedBtn, selectedSession, page, subject } = useSegmentReFetch();

  const [toggleUnlockModal, settoggleUnlockModal] = useState(false);

  const payload = decodeToken();

  const isDashboard =
    payload &&
    payload.hasOwnProperty("programtype") &&
    payload.programtype === DASHBOARD_PROGRAME;

  const isSelfPaced =
    payload &&
    payload.hasOwnProperty("programtype") &&
    payload.programtype === SELF_PACED_PROGRAME;

  const testtype =
    payload && payload.hasOwnProperty("testtype") && payload.testtype;

  const navigate = useNavigate();

  const userId = payload ? payload.userid : null;
  const productCode = payload ? payload.productcode : null;
  const offeringCode = payload ? payload.offeringcode : null;

  useEffect(() => {
    if (middleLabel && middleLabel.length > 5) {
      setResponsiveMiddleLabel(middleLabel.slice(0, 5) + "...");
    }
  }, []);

  const screen = useScreenSize();
  const { aiMCATChatDrawerStatus } = useAppSelector(
    (state: { layout: { aiMCATChatDrawerStatus: ai_mcat_chat_status } }) =>
      state.layout
  );
  const { isFetching, refetch } = useGetPracticeTestsQuery();
  const { isFetching: graphDataIsFetching, refetch: graphDataReFetch } =
    useGetTestResultsQuery();

  const { refetch: refetchTestScores, isFetching: isfetchingTestScores } =
    useGetTestScoresAndPerformanceQuery();

  const {
    refetch: refetchOverAllProgress,
    isFetching: isFetchingOverallProgress,
  } = useGetOverallProgressQuery({
    Userid: userId,
    Productcode: productCode,
    Offeringcode: offeringCode,
  });

  const { refetch: refetchCoursework, isFetching: isFetchingCoursework } =
    useGetCourseworkQuery({
      page: page,
      ...(isDashboard
        ? {
            selectedOption: parseInt(
              getObjectKeysByValue(selectedBtn, true)[0],
              10
            ),
          }
        : {}),
      ...(isDashboard
        ? {
      timeFilter:
        selectedSession === null
          ? 1
          : getTimeFilterInput(Object.values(selectedSession)[0]),
          }
        : {}),
      ...(isSelfPaced && testtype === MCAT_TEST_TYPE
        ? {
            subject: subject,
          }
        : {}),
    });

  const handleStyleWithDrower = () => {
    return (
      screen.width > 1550 &&
      screen.width < 1950 &&
      aiMCATChatDrawerStatus === "open"
    );
  };

  const handlePrimaryBtnClick = () => {
    switch (item.LaunchTests.length) {
      case 2:
        setModalSelector("both");
        setBubbleSheetPdfUrl(item.PdfUrl);
        setIsModalOpen(true);

        if (item.LaunchTests[0].DeliveryType === "Online") {
          if (item.LaunchTests[1].ProctorUrl) {
            setOnlineProctor_1(
              item.LaunchTests[1].ProctorUrl["Online Proctor"]
            );
            setOnlineProctor_2(
              item.LaunchTests[1].ProctorUrl["Online Proctor 1.5x Timer"]
            );
            setOnlineProctor_3(
              item.LaunchTests[1].ProctorUrl["Online Proctor 2x Timer"]
            );
          }
        } else {
          if (item.LaunchTests[0].ProctorUrl) {
            setOnlineProctor_1(
              item.LaunchTests[0].ProctorUrl["Online Proctor"]
            );
            setOnlineProctor_2(
              item.LaunchTests[0].ProctorUrl["Online Proctor 1.5x Timer"]
            );
            setOnlineProctor_3(
              item.LaunchTests[0].ProctorUrl["Online Proctor 2x Timer"]
            );
          }
        }

        break;
      case 1:
        if (item.LaunchTests[0].DeliveryType === "Online") {
          if (item.LaunchTests[0].LaunchUrl) {
            const testtype = payload?.testtype;
            openExternalUrl({
              url: item.LaunchTests[0].LaunchUrl,
              title: "Practice Test",
              contentObjectType: item.ContentObjectType,
              testType: testtype,
              dispatch,
              onRefreshModalOpen: () => {
                setIsRefreshModalOpen((prev) => ({
                  ...prev,
                  isOpen: true,
                  data: "Practice Test",
                }));
              },
            });
          }
        } else {
          setModalSelector("paper & pencil");
          setBubbleSheetPdfUrl(item.PdfUrl);

          if (item.LaunchTests[0].ProctorUrl) {
            setOnlineProctor_1(
              item.LaunchTests[0].ProctorUrl["Online Proctor"]
            );
            setOnlineProctor_2(
              item.LaunchTests[0].ProctorUrl["Online Proctor 1.5x Timer"]
            );
            setOnlineProctor_3(
              item.LaunchTests[0].ProctorUrl["Online Proctor 2x Timer"]
            );
          }
          setIsModalOpen(true);
        }
        break;
      default:
        break;
    }

    // if (primaryBtnLink) {
    //   window.location.href = primaryBtnLink;
    // }
  };

  const handleUnlockBtnClick = () => {
    settoggleUnlockModal(true);
  };

  const handleUpgradeCourse = () => {
    if (payload && payload.hasOwnProperty("freeToPaidUpgradeLink")) {
      window.open(payload.freeToPaidUpgradeLink, "__blank");
      setTimeout(() => {
        settoggleUnlockModal(false);
        setIsRefreshModalOpen((prev) => ({
          ...prev,
          isOpen: true,
          data: "Purchase",
        }));
      }, 500);
    }
  };

  const handleSecondaryBtnClick = () => {
    if (secondaryBtnLink) {
      mixpanelHelper.track("View Score Report", {
        InstanceID: "",
        segmentID: "",
        segmentDescription: "",
        sourceID: "",
        courseProgress: "",
        contentObjectID: "",
        testType: "",
        productCode: productCode,
        psoCode: offeringCode,
        userID: userId,
      });
      openExternalUrl({
        url: secondaryBtnLink,
        title: "Score Report",
        testType: testtype,
        dispatch,
      });
    }
  };

  const handleModalClose = () => {
    setIsModalOpen(false);
  };

  const handleModalTypeSelector = (type: string) => {
    if (type === "both") {
      setModalSelector("both");
    } else {
      setModalSelector("paper & pencil");
    }

    setIsModalOpen(true);
  };

  const handleRefresh = async () => {
    await refetch();
    await graphDataReFetch();
    await refetchOverAllProgress();
    await refetchTestScores();
    await refetchCoursework();
    handleRefreshModalClose();
  };

  const handleRefreshModalClose = () => {
    setIsRefreshModalOpen((prev) => ({ ...prev, isOpen: false, data: "" }));
  };

  const handleRefreshModalOpen = () => {
    setIsRefreshModalOpen((prev) => ({ ...prev, isOpen: true }));
  };

  return (
    <div
      className={classNames(
        "practice-tab-row-wrapper",
        {
          "bg-white": index % 2 === 0,
          "bg-blue": index % 2 !== 0,
          "bg-gray-test": iconType === "lock",
        },
        screen.width > MOBILE_WIDTH && screen.width <= TAB_WIDTH
          ? "tab-style"
          : ""
      )}
    >
      {screen.width <= 1024 ? (
        <div className="practice-tab-size-wrapper">
          <div
            className={classNames({
              "icon-text-section": true,
              "text-gray": iconType === "lock",
            })}
          >
            <TextIcon
              label={textIconLabel}
              icon={true}
              isReverse={true}
              iconType={iconType}
              isTabStyle={true}
              theme={theme}
            />
          </div>

          <div
            className={classNames({
              "middle-section": true,
              "text-gray": iconType === "lock",
            })}
          >
            <Typography
              variant="h8Med"
              label={
                middleLabel === "Not started" ? "Not Started" : middleLabel
              }
              styles="custom-middle-practice-style"
            />
          </div>
        </div>
      ) : (
        <>
          <div
            className={classNames({
              "icon-text-section": true,
              "text-gray": iconType === "lock",
            })}
          >
            <TextIcon
              label={textIconLabel}
              icon={true}
              isReverse={true}
              iconType={iconType}
              isTabStyle={true}
              theme={theme}
            />
          </div>

          <div
            className={classNames({
              "middle-section": true,
              "text-gray": iconType === "lock",
            })}
          >
            <Typography
              variant="h8Med"
              label={
                middleLabel === "Not started" ? "Not Started" : middleLabel
              }
              styles="custom-middle-practice-style"
            />
          </div>
        </>
      )}

      <div className={classNames("btn-section",handleStyleWithDrower()?"btn-section-for-drawer-styles":"")}>
        {iconType === "lock" ? (
          <Button
            type="score"
            icon={false}
            label="Unlock All Content"
            styles="tab-layout-home-page-custom-style-btn"
            onClick={handleUnlockBtnClick}
          />
        ) : (
          <>
            {isSecondBtn && (
              <Button
                type="online"
                icon={false}
                label={secondBtnLabel}
                styles="practice-second-btn-custom-style"
                onClick={handleSecondaryBtnClick}
              />
            )}

            {isBtn && (
              <Button
                type="score"
                icon={false}
                label={btnLabel}
                styles="custom-btn-style"
                onClick={handlePrimaryBtnClick}
              />
            )}
          </>
        )}
      </div>
      <Modal isOpen={isModalOpen} onClose={handleModalClose} theme={"light"}>
        <div className="practice-modal-wrapper">
          <div
            className="header"
            style={
              theme === "light"
                ? { backgroundColor: "#233851" }
                : { backgroundColor: "#329EE2" }
            }
          >
            <div className="header-topic">
              <Typography
                label={
                  modalSelector === "both"
                    ? "Select Your Desired Test Format"
                    : "Paper and Pencil Test"
                }
                variant="h4Bold"
                styles={
                  theme === "light"
                    ? "title-typography-custom-style-light"
                    : "title-typography-custom-style-dark"
                }
              />
            </div>
            <div className="close-icon" onClick={handleModalClose}>
              <CloseIcon theme={theme} />
            </div>
          </div>
          <div
            className="body"
            style={
              theme === "dark"
                ? { backgroundColor: "#1c1f23" }
                : { backgroundColor: "#ffffff" }
            }
          >
            {modalSelector === "both" && item.LaunchTests[0] ? (
              <PracticeModalInnerCard
                theme={theme}
                modalSelector={modalSelector}
                type="online"
                isPdfUrl={item.PdfUrl}
                title="Online"
                description="Complete all the questions in this section and see your results and the explanations at the end"
                btnLabel="Launch Online Test"
                launchUrl={
                  item.LaunchTests && item.LaunchTests[0]
                    ? item.LaunchTests[0].DeliveryType === "Online"
                      ? item.LaunchTests[0].LaunchUrl
                      : item.LaunchTests[1] && item.LaunchTests[1].LaunchUrl
                        ? item.LaunchTests[1].LaunchUrl
                        : ""
                    : ""
                }
                handleModalClose={handleModalClose}
                handleRefreshModalOpen={handleRefreshModalOpen}
              />
            ) : null}

            <PracticeModalInnerCard
              theme={theme}
              modalSelector={modalSelector}
              type="bubble-sheet"
              isPdfUrl={item.PdfUrl}
              pdfUrl={item.PdfUrl}
              title="Bubblesheet"
              description="Complete all the questions in this section by entering your answers in a bubblesheet"
              btnLabel="Launch Bubblesheet"
              onlineProctor_1={onlineProctor_1}
              onlineProctor_2={onlineProctor_2}
              onlineProctor_3={onlineProctor_3}
              launchUrl={
                item.LaunchTests &&
                item.LaunchTests[0] &&
                item.LaunchTests[0].LaunchUrl
                  ? modalSelector === "both" &&
                    item.LaunchTests[1] &&
                    item.LaunchTests[1].LaunchUrl
                    ? item.LaunchTests[0].DeliveryType === "Online"
                      ? item.LaunchTests[1].LaunchUrl
                      : item.LaunchTests[0].LaunchUrl
                    : item.LaunchTests[0].LaunchUrl
                  : ""
              }
              handleModalClose={handleModalClose}
              handleRefreshModalOpen={handleRefreshModalOpen}
            />
          </div>
        </div>
      </Modal>
      <RefreshModal
        theme={theme}
        handleOnClose={handleRefreshModalClose}
        isOpen={isRefreshModalOpen.isOpen}
        handleRefresh={handleRefresh}
        contentObjectType={
          isRefreshModalOpen.data !== ""
            ? isRefreshModalOpen.data
            : contentObjectType
              ? contentObjectType
              : "test"
        }
        isFetching={
          isFetching ||
          graphDataIsFetching ||
          isFetchingCoursework ||
          isfetchingTestScores ||
          isFetchingOverallProgress
        }
      />
      <UnlockModal
        handleUnlockModalClose={() => settoggleUnlockModal(false)}
        handleUpgrade={handleUpgradeCourse}
        unlockModalState={toggleUnlockModal}
        theme={theme}
      />
      {/* ScoreReportModal now rendered globally in App.tsx */}
    </div>
  );
};
